import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';

import { TAccount } from './accounts.types';

/**
 * Determines if an account is a micro loan (credit_facility with duration < 12 months)
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsMicroLoan = (account: TAccount) => {
    return Boolean(
        ['credit_facility'].includes(account.product_type) &&
        getDurationInMonths(account.duration!) < 12
    );
};
